import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  fieldObjectKits,
  headersKitsProdutos,
  valoresExibidosOffCanvasKitProdutos,
} from './auxiliarKitProdutos';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomButton from '../../../../components/CustomButton';
import CustomCol from '../../../../components/CustomCol';
import CustomRow from '../../../../components/CustomRow';
import CustomSpan from '../../../../components/CustomSpan';
import Input from '../../../../components/InputNew';
import Select from '../../../../components/InputNew/Select';
import Tabela from '../../../../components/Tabela';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import { getUser } from '../../../../modules/contexts/Auth/RequireAuth';
import { UserContext } from '../../../../modules/contexts/Auth/UserProvider';
import { UserVinculoToken } from '../../../../modules/types/UsuarioVinculo';
import { useComponentesPaf } from '../../../../services/enum/useComponentesPaf';
import { useStatusKit } from '../../../../services/enum/useStatusKit';
import { getAllKitDeProduto as getAll } from '../../../../services/produtosDAF/kitProdutoService';
import { ENTITY } from '../../../../utils/entityNames';
import {
  ExportToExcel,
  formataNomeMeioSiglas,
  formatDate,
} from '../../../../utils/functions';
import SubAbas from '../subabas';

//DADOS USUARIO

const KitsIndex: React.FC = () => {
  const { cudProdutoDaf } = useContext(UserContext);
  const CACHE_KEY = 'cachedKits';
  const CACHE_EXPIRATION = 60 * 60 * 1000;

  const navigate = useNavigate();
  const componenteAf = useComponentesPaf();
  const statusKit = useStatusKit();

  //Dados do componente
  const [formFiltros, setFormFiltros] = useState({
    statusKit: 0,
    componenteAF: 0,
    nomeKit: '',
  });
  const [data, setData] = useState<any[]>([]);

  // Buscar dados
  // const fetchData = async () => {
  //   try {
  //     const registros = await getAll();
  //     setData(registros);
  //   } catch (error) {
  //     console.error('Erro ao obter dados:', error);
  //   }
  // };
  // useEffect(() => {
  //   fetchData();
  // }, []);
  const fetchData = async () => {
    try {
      const cachedData = localStorage.getItem(CACHE_KEY);
      const now = new Date().getTime();

      // Verifica se há cache válido
      if (cachedData) {
        const { timestamp, data } = JSON.parse(cachedData);
        const timeDifference = now - timestamp;

        if (timeDifference < CACHE_EXPIRATION) {
          setData(data); // Usa os dados do cache sem buscar na API
          return;
        } else {
          localStorage.removeItem(CACHE_KEY);
        }
      }

      // Busca da API apenas se não houver cache ou se estiver expirado
      const registros = await getAll();
      setData(registros);

      localStorage.setItem(
        CACHE_KEY,
        JSON.stringify({ timestamp: now, data: registros }),
      );
    } catch (error) {
      console.error('❌ Erro ao obter dados:', error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const tableData = data
    .map((item) => ({
      id: item.id,
      statusKit:
        item.statusKit === 1 ? (
          <CustomSpan texto="Ativo" />
        ) : (
          <CustomSpan texto="Inativo" />
        ),
      componenteAF:
        componenteAf?.find(
          (option) => option.value === item.componenteAF?.toString(),
        )?.label || 'Não informado',

      nomeKit: item.nomeKit,
      produtos:
        item.produtos?.length > 0 ? (
          <ul style={{ marginBottom: '2px', paddingLeft: '20px' }}>
            {item.produtos
              ?.sort((a: any, b: any) =>
                a.produtoFarmaceutico.localeCompare(b.produtoFarmaceutico),
              ) // Ordena os produtos
              .map((produto: any, index: number) => (
                <li key={index} style={{ marginBottom: '5px' }}>
                  <b>{produto.produtoFarmaceutico}</b>
                  <br />
                  <span style={{ marginLeft: '0px' }}>
                    Quantidade por Kit: {produto.quantidade?.toLocaleString()}{' '}
                    unidades
                  </span>
                </li>
              ))}
          </ul>
        ) : (
          <span style={{ fontStyle: 'italic', color: '#888' }}>
            Não informado
          </span>
        ),
    }))
    .filter((item: any) => {
      const statusKitLabel = statusKit?.find(
        (option) => option.value === formFiltros.statusKit?.toString(),
      )?.label;

      const componenteAFLabel = componenteAf?.find(
        (option) => option.value === formFiltros.componenteAF?.toString(),
      )?.label;

      return (
        (formFiltros.statusKit === 0 ||
          item.statusKit?.props?.texto === statusKitLabel) &&
        (formFiltros.componenteAF === 0 ||
          item.componenteAF === componenteAFLabel) &&
        (formFiltros.nomeKit === '' ||
          item.nomeKit
            ?.toLowerCase()
            .includes(formFiltros.nomeKit.toLowerCase()))
      );
    });

  //Dados do Offcanvas
  const offCanvasData = data.map((item) => ({
    id: item.id,
    dataRegistro:
      formatDate(item.dataRegistro) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
    dataUltimaAtualizacao:
      formatDate(item.dataUltimaAtualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),

    dataUltimaVisualizacao:
      formatDate(item.dataUltimaVisualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
    nEdicoes: item.nEdicoes,
    nVisualizacoes: item.nVisualizacoes,
    separadorLog: '',
    // statusKit: item.statusKit ? statusKit[item.statusKit].label : null,
    statusKit:
      item.statusKit === 1 ? (
        <CustomSpan texto="Ativo" />
      ) : (
        <CustomSpan texto="Inativo" />
      ),
    componenteAF:
      componenteAf?.find(
        (option) => option.value === item.componenteAF?.toString(),
      )?.label || 'Não informado',
    nomeKit: item.nomeKit,
    descricao: item.descricao,
    produtos: (
      <ul style={{ marginBottom: '2px' }}>
        {item.produtos
          .sort((a: any, b: any) =>
            a.produtoFarmaceutico.localeCompare(b.produtoFarmaceutico),
          ) // Ordena os produtos
          .map((produto: any, index: number) => (
            <li key={index} style={{ marginBottom: '5px' }}>
              <b>{produto.produtoFarmaceutico}</b>
              <br />
              <span
                style={{
                  marginLeft: '0px',
                }}
              >
                Quantidade por Kit: {produto.quantidade.toLocaleString()}{' '}
                unidades
              </span>
            </li>
          ))}
      </ul>
    ),

    separadorObservacoes: '',
    observacoes: item.observacoes,
  }));

  const handleInserir = () => {
    navigate('dadosgerais');
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;

    if (name === 'componenteAF') {
      const newValue = parseInt(value, 10);
      setFormFiltros({
        ...formFiltros,
        componenteAF: newValue,
      });
    } else {
      setFormFiltros((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleClearFiltros = () => {
    setFormFiltros({
      ...formFiltros,
      statusKit: 0,
      componenteAF: 0,
      nomeKit: '',
    });
  };

  interface ExportData {
    id: number;
    dataRegistro: string;
    usuarioRegistro: {
      nomeCompleto: string;
    };
    dataUltimaAtualizacao: string;
    usuarioAtualizacao: {
      nomeCompleto: string;
    };
    dataUltimaVisualizacao: string;
    usuarioUltimaVisualizacao: {
      nomeCompleto: string;
    };
    nEdicoes: number;
    nVisualizacoes: number;
    nVisualizadores: number;

    //Específicos
    componenteAF: number;
    nomeKit: string;
    descricao: string;

    //Observações
    observacoes: string;
  }

  const prepareDataForExport = (data: ExportData[]) => {
    return data.map((item) => {
      return {
        id: item.id,

        //Logs
        dataRegistro: item.dataRegistro,
        usuarioRegistro: item.usuarioRegistro.nomeCompleto,
        dataUltimaAtualizacao: item.dataUltimaAtualizacao,
        usuarioAtualizacao: item.usuarioAtualizacao.nomeCompleto,
        dataUltimaVisualizacao: item.dataUltimaVisualizacao,
        usuarioUltimaVisualizacao: item.usuarioUltimaVisualizacao.nomeCompleto,
        nEdicoes: item.nEdicoes,
        nVisualizacoes: item.nVisualizacoes,
        nVisualizadores: item.nVisualizadores,

        //Específicos
        componenteAF: componenteAf[item.componenteAF].label,
        nomeKit: item.nomeKit,
        descricao: item.descricao,

        //Observações
        observacoes: item.observacoes,
      };
    });
  };

  const filteredDataForExport = data.filter((item) => {
    return (
      (formFiltros.statusKit === 0 ||
        item.statusKit ===
          statusKit.find(
            (option) => option.value === formFiltros.statusKit.toString(),
          )?.label) &&
      (formFiltros.componenteAF === 0 ||
        item.componenteAF ===
          componenteAf.find(
            (option) => option.value === formFiltros.componenteAF.toString(),
          )?.label) &&
      (formFiltros.nomeKit === '' ||
        item.nomeKit.toLowerCase().includes(formFiltros.nomeKit.toLowerCase()))
    );
  });

  return (
    <>
      <BarraSubAbas subAbas={SubAbas} />

      <ContainerConteudo>
        <BoxConteudo boxTitulo="Filtros" fechado>
          <CustomRow style={{ marginTop: '-15px' }}>
            <CustomCol width="200px">
              <Select
                name="statusKit"
                value={formFiltros.statusKit}
                options={statusKit}
                onChange={handleChange}
                label="Status"
              />
            </CustomCol>
            <CustomCol width="200px">
              <Select
                name="componenteAF"
                value={formFiltros.componenteAF}
                options={componenteAf}
                onChange={handleChange}
                label="Componente AF"
              />
            </CustomCol>

            <CustomCol>
              <Input
                id="nomeKit"
                name="nomeKit"
                value={formFiltros.nomeKit}
                label="Nome do Kit"
                onChange={handleChange}
              />
            </CustomCol>
          </CustomRow>
          <CustomRow style={{ marginTop: '-15px', textAlign: 'right' }}>
            <CustomCol className="mt-3 justify-content-end align-content-end">
              <CustomButton
                label="Limpar filtros"
                bgColor="#808080"
                textColor="#ffffff"
                onClick={handleClearFiltros}
              />
            </CustomCol>
          </CustomRow>
        </BoxConteudo>

        <Tabela
          headers={headersKitsProdutos}
          dataTable={tableData}
          dataOffCanvas={offCanvasData}
          displayValues={valoresExibidosOffCanvasKitProdutos}
          tituloCanvas="KITS DE PRODUTOS DAF"
        />
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          // download
          // onClickDownload={() =>
          //   ExportToExcel(
          //     prepareDataForExport(filteredDataForExport),
          //     valoresExibidosOffCanvasKitProdutos,
          //     fieldObjectKits,
          //     'sisaf_kits_produtos.xlsx',
          //     userID,
          //     'DAF', // Nome da interface
          //     entity, // Nome da entidade
          //   )
          // }
          inserir
          onClickInserir={handleInserir}
          inserirDisabled={!cudProdutoDaf}
        />
      </BarraInferiorBotoes>
    </>
  );
};

export default KitsIndex;
